import { PageBlock } from "@ui/page-block"
import { GetServerSideProps } from "next"
import { SignupPageQuery, SignupPageQueryVariables } from "@graph/types/SignupPageQuery"
import SIGNUP_QUERY from "@graph/queries/page-signup.gql"
import { ServerResponse } from "@server/response"
import { PageProps } from "@server/props"
import Image from "next/image"
import { Row } from "@ui/row"
import withLove from "@icons/with-love.svg"
import motherhood from "@icons/motherhood.svg"
import { SignupCard, SignupCardProps } from "@cards/signup-form"
import { PageHeader } from "@ui/pages"
import { createServerClient } from "@graph/client"
import { TopbarLayout } from "@layouts/topbar"

type SignupPageProps = PageProps<
  SignupCardProps & {
    referral?: { firstName: string } | null
  }
>

export default function SignupPage({ referral, prefill }: SignupPageProps) {
  const image = referral ? withLove : motherhood

  return (
    <TopbarLayout title="Signup">
      <PageBlock>
        <PageHeader
          heading="Focus on what matters most"
          headline={referral ? <ReferralPrompt {...referral} /> : <RegularPrompt />}
        />

        <Row>
          <Row.Column variant="primary">
            <SignupCard autoFocus prefill={prefill} />
          </Row.Column>

          <Row.Column variant="secondary">
            <Image alt="" width={image.width} height={image.height} src={image.src} layout="responsive" />
          </Row.Column>
        </Row>
      </PageBlock>
    </TopbarLayout>
  )
}

const ReferralPrompt = ({ firstName }: { firstName: string }) => (
  <>
    Your friend <strong>{firstName}</strong> uses HeartPayroll to pay their employees (and thinks you should, too). Sign
    up today to earn{" "}
    <strong>
      <em>$50</em>
    </strong>
    .
  </>
)

const RegularPrompt = () => <>Join thousands of people who use HeartPayroll every day to pay their employees.</>

export const getServerSideProps: GetServerSideProps<SignupPageProps> = async (ctx) => {
  const firstName = (ctx.query["first_name"] as string) || ""
  const lastName = (ctx.query["last_name"] as string) || ""
  const email = (ctx.query["email"] as string) || ""
  const phoneNumber = (ctx.query["phone_number"] as string) || ""
  const referralCode = (ctx.query["referral_code"] as string) || ""

  const client = createServerClient({ headers: ctx.req.headers })

  const { data } = await client.query<SignupPageQuery, SignupPageQueryVariables>({
    query: SIGNUP_QUERY,
    variables: {
      referralCode,
    },
  })

  if (data.user) {
    return ServerResponse.redirect("/")
  }

  return {
    props: {
      ...data,
      prefill: {
        firstName,
        lastName,
        email,
        phoneNumber,
        referralCode,
      },
    },
  }
}
